import { memo } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import WalletSection from '../WalletSection/WalletSection';
import AccountSection from '../AccountSection/AccountSection';
import LogoutSection from '../LogoutSection/LogoutSection';
import Logo from '../Logo/Logo';
import { StyledHeader } from '../styled';

// --- Mobile hamburger icon ---
const StyledNavigationIcon = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    width: 45px;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #707070;
    font-size: 20px;
    margin-right: 10px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #e5e5e5;
    }
  }
`;

// --- Logo container ---
const StyledLogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const StyledRightSections = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 15px; /* spacing between wallet/account/logout */
`;

const Header = memo(
  ({
    fullName,
    profilePhoto,
    onClickLogout,
    gstBuyerWallet,
    gstSellerWallet,
    appData: { appLogo, appName },
    showNav,
    setShowNav,
  }) => {
    const toggleNav = () => setShowNav(!showNav);

    return (
      <StyledHeader>
        {/* Mobile Hamburger */}
        <StyledNavigationIcon onClick={toggleNav}>
          <FontAwesomeIcon icon={showNav ? faXmark : faBars} />
        </StyledNavigationIcon>

        {/* Logo */}
        <StyledLogoContainer>
          <Logo appLogo={appLogo} appName={appName} style={{ width: '150px' }} />
        </StyledLogoContainer>

        {/* Right-side sections */}
        <StyledRightSections>
          <WalletSection gstBuyerWallet={gstBuyerWallet} gstSellerWallet={gstSellerWallet} />
          <AccountSection fullName={fullName} profilePhoto={profilePhoto} />
          <LogoutSection onClickLogout={onClickLogout} />
        </StyledRightSections>
      </StyledHeader>
    );
  }
);

export default Header;
